export const APP_DETAILS = "APP_DETAILS";
export const BANK_DETAILS = "BANK_DETAILS";
export const BANNERS = "BANNERS";

export const SHOW_RIGHT_SIDEBAR = "SHOW_RIGHT_SIDEBAR";
